up.compiler("#up_add_workshopper", function (element) {
  const fullData = JSON.parse(element.dataset.full);
  const exceptData = JSON.parse(element.dataset.except) || [];
  const fresk_slug = element.dataset.freskslug;
  const workshop_slug = element.dataset.workshopslug;
  const exceptSlug = exceptData.map((e) => e.slug);

  const choiceList = fullData
    .map((e) => {
      let res = {
        value: e.slug,
        label: e.first_name + " " + e.last_name,
      };
      return res;
    })
    .filter((e) => !exceptSlug.includes(e.value));

  const selector = new Choices(element, {
    choices: choiceList,
    placeholder: true,
    placeholderValue: "Ajouter un.e animateur.rice",
    removeItemButton: true,
    classNames: {
      containerOuter: ["choices", "w-full"],
      containerInner: [
        "choices__inner",
        "!py-3",
        "text-base",
        "flex",
        "items-center",
        "justify-between",
        "rounded-lg",
        "border",
        "border-[#B3C1BA]",
        "border-input",
        "bg-white",
        "text-xs",
      ],
      item: ["choices__item"],
      input: ["choices__input"],
      placeholder: ["choices__placeholder", "text-foreground"],
    },
  });
  // force actual value
  selector.setChoiceByValue(element.value);
  // reset all
  selector.removeActiveItems();

  function handleAddItem(event) {
    const animator_slug = event.target.value;
    up.render({
      url: `/manage-workshops/add-workshopper/${fresk_slug}/${workshop_slug}/${animator_slug}`,
      method: "post",
      target: "#workshoppers, .js-wshop-img.is-active, .js-wshop-pro.is-active",
    });
  }

  element.addEventListener("addItem", handleAddItem);

  return () => {
    element.removeEventListener("addItem", handleAddItem);
    selector.destroy();
  };
});
